import { fromJS } from 'immutable';
import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function linkedCryodexReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.CRYODEX_CRYODEX_LINKED_UPDATE:
        return {
        ...state,
        data: action.payload,
        };
    default:
      return state;
  }
}

export default linkedCryodexReducer;
